import { ParamListBase } from '@react-navigation/native';
import { RouteParamsWeb } from './types';
import { useQueryParams } from 'use-query-params';

export const useRouteParams = <T extends ParamListBase, K extends keyof T>(
    path: K,
    routeParams: RouteParamsWeb<T>,
) => {
    const params = routeParams[path];
    const [queryParams] = useQueryParams(params);
    return { params: queryParams as T[K] }; // casting necessary to maintain intellisense
};
